import React, { useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSlate } from 'slate-react';
import { Node } from 'slate';

import { SLATE_ACTIONS } from '../../../const';
import { ActionButton } from './ActionButton';

const serialize = (nodes) => {
  return nodes.map((n) => Node.string(n));
};

export const ToolbarUndoRedoActions = ({ onClearFormatting, className }) => {
  const editor = useSlate();

  const handleActionClick = useCallback(
    (action) => {
      switch (action) {
        case SLATE_ACTIONS.UNDO:
          editor.undo();
          break;
        case SLATE_ACTIONS.REDO:
          editor.redo();
          break;
        case SLATE_ACTIONS.CLEAR_FORMAT:
          const nodes = serialize(editor.children);
          const plainText = nodes.map((n) => `<p>${n}</p>`).join('');
          onClearFormatting(plainText);
          break;
        default:
          break;
      }
    },
    [editor, onClearFormatting]
  );

  return (
    <Fragment>
      {[SLATE_ACTIONS.UNDO, SLATE_ACTIONS.REDO].map((action) => {
        return (
          <ActionButton
            key={action}
            action={action}
            className={className}
            onClick={handleActionClick}
          />
        );
      })}
    </Fragment>
  );
};

ToolbarUndoRedoActions.propTypes = {
  className: PropTypes.string,
  onClearFormatting: PropTypes.func.isRequired,
};

ToolbarUndoRedoActions.defaultProps = {
  className: '',
};
